import {
  WorkflowStepKind,
  WorkflowDashboardRunDto,
  WorkflowDashboardStepDto,
  WorkflowStepInstanceStatus,
} from 'src/@types/workflow/types';

import { STEP_KINDS } from 'src/sections/shared/workflow/stepKind';

export type RenderableRunStep = {
  step: WorkflowDashboardStepDto;
  kind: WorkflowStepKind;
};

const isCompleted = (step: WorkflowDashboardStepDto) =>
  step.status === WorkflowStepInstanceStatus.Completed;

const isAwaitingAction = (step: WorkflowDashboardStepDto) =>
  step.status === WorkflowStepInstanceStatus.Active;

export const activeStepOf = (run: WorkflowDashboardRunDto) => run.steps.find(isAwaitingAction);

export const isWaitingOn = (run: WorkflowDashboardRunDto, email?: string) =>
  run.steps.some((step) => isAwaitingAction(step) && step.assigneeEmail === email);

export const completedStepCount = (run: WorkflowDashboardRunDto) =>
  run.steps.filter(isCompleted).length;

export const orderedRenderableSteps = (run: WorkflowDashboardRunDto): RenderableRunStep[] =>
  run.steps
    .filter((step) => step.status !== WorkflowStepInstanceStatus.Skipped)
    .sort((left, right) => left.stepOrder - right.stepOrder)
    .map((step) => ({ step, kind: step.stepType as WorkflowStepKind }))
    .filter(({ kind }) => STEP_KINDS[kind] !== undefined);
